import { getValue } from '@/utils';
import { PREFERENCES } from '@/const';

export const getDarkMode = () => {
  const localValue = getValue(PREFERENCES.PREFER_DARK_MODE);
  if (localValue !== null) {
      return localValue
  }
  const browserSetting = (window.matchMedia || ((a1: string) => ({ matches: false })))(
    '(prefers-color-scheme: dark)',
  ).matches;
  return false || browserSetting;
};
